var _SocketShareStreamCommand_stream;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import Axios from 'axios';
import { SessionService } from '../../../service/SessionService';
export class SocketShareStreamCommand {
    constructor(param) {
        _SocketShareStreamCommand_stream.set(this, void 0);
        __classPrivateFieldSet(this, _SocketShareStreamCommand_stream, param, "f");
    }
    execute() {
        const url = 'https://mycast.xyz:8002/stream/';
        const privateKey = SessionService.getPrivateKey();
        const msg = JSON.stringify({
            keyId: __classPrivateFieldGet(this, _SocketShareStreamCommand_stream, "f").keyid,
            icon: __classPrivateFieldGet(this, _SocketShareStreamCommand_stream, "f").icon,
            nickname: __classPrivateFieldGet(this, _SocketShareStreamCommand_stream, "f").title,
            platform: __classPrivateFieldGet(this, _SocketShareStreamCommand_stream, "f").platform,
            description: __classPrivateFieldGet(this, _SocketShareStreamCommand_stream, "f").description,
            thumbnail: __classPrivateFieldGet(this, _SocketShareStreamCommand_stream, "f").thumbnail,
            link: __classPrivateFieldGet(this, _SocketShareStreamCommand_stream, "f").url,
            viewer: __classPrivateFieldGet(this, _SocketShareStreamCommand_stream, "f").viewer,
        });
        const param = new URLSearchParams({ user: privateKey, msg });
        Axios.post(url, param.toString());
    }
}
_SocketShareStreamCommand_stream = new WeakMap();
